interface Props { initials: string; size?: number; color?: string; }

export default function Avatar({ initials, size=36, color="#059669" }: Props) {
  return (
    <div style={{ width:size, height:size, borderRadius:"50%", background:color,
      display:"flex", alignItems:"center", justifyContent:"center",
      color:"#fff", fontWeight:500, fontSize:size*0.34, flexShrink:0 }}>
      {initials}
    </div>
  );
}
